import React from 'react';
import axios from 'axios';
import {BASE, DOWNLOAD_FICHE_DEVIS, FIND_FICHE_BY_CODE, FIND_FICHE_BY_FETCH_CODE, LOAD_DETAILS} from "../../../api/Api";
import {Link, Redirect, Route, Switch, useLocation, useParams} from 'react-router-dom'
import {Divider, ExpansionPanelDetails as AccordionDetails} from "@material-ui/core";
import {Field} from "formik";
import TextField from "../../../components/Ui/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import GoogleMapsInput from "../../../components/FormFields/Fiche/GoogleMapsInput";
import FileInput from "../../../components/Ui/FileInput";
import BootstrapLoadingButton from "../../../components/Ui/BootstrapLoadingButton";
import GoogleMapsComponent from "../../../components/Ui/GoogleMapsComponent";
import {makeStyles} from '@material-ui/core/styles';
import moment from 'moment'

import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import StepContent from '@material-ui/core/StepContent';
import {convertToLocalState, getFicheLocalStateDate, getFileUrl} from "../../../utils/helpers";
import {
    FICHE_STATES,
    societes,
    STATE_ANALYSE,
    STATE_PRISE_EN_COMPTE,
    STATE_SAVED,
    STATE_TERMINER
} from "../../../utils/constants";
import FicheCommentSection from "../../../components/Modules/Fiches/FicheCommentSection";
import SimpleTabMenu from "../../../components/Ui/SimpleTabMenu";
import DocumentsPage from "../../Fiches/FicheDetails/DocumentsPage/DocumentsPage";
import StateView from "../../../components/Ui/StateView";
import NewFicheCommandeModal from "../../../components/Modals/Fiches/NewFicheCommandeModal";
import HistoryPage from "../../Fiches/FicheDetails/HistoryPage/HistoryPage";
import RecapitulatifPage from "../../Fiches/FicheDetails/RecapitulatifPage/RecapitulatifPage";
import StatePage from "../../Fiches/FicheDetails/StatePage/StatePage";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    button: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
    },
    actionsContainer: {
        marginBottom: theme.spacing(2),
    },
    resetContainer: {
        padding: theme.spacing(3),
    },
    details: {
        background: 'white'
    }
}));

function getSteps() {
    return ['Demande enregistré', 'Analyse de votre demande', 'Prise en compte de votre demande', 'Realisation terminé'];
}

function getStepContent(step) {
    switch (step) {
        case 0:
            return `Enregistrement de la demande. Début du procéssus`;
        case 1:
            return 'Nos agents analyse les informations envoyer lors de votre demande et se prépare à y répondre en cas de suite favorable.';
        case 2:
            return `Votre demande a été prise en compte. Nos équipe devront vous contacterons pour l'intervention.`;
        case 3:
            return `La demande a été exécuté avec succès. Les éléments on été déplacé`;
        default:
            return 'Unknown step';
    }
}


export function canDownloadDevis(state){

    return state == 'App\\Models\\Fiches\\States\\DevisSendedStep'
        // || state == 'App\\Models\\Fiches\\States\\StudyFinishedStep'
        // || state == 'App\\Models\\Fiches\\States\\CommandSendedStep'
        // || state == 'App\\Models\\Fiches\\States\\WorkInProgressStep'
        // || state == 'App\\Models\\Fiches\\States\\WorkFinishedStep';
}

export function canDownloadDevisMO(state){

    return state == 'App\\Models\\Fiches\\States\\DevisMOSendedStep'
        || state == 'App\\Models\\Fiches\\States\\CloturedStep'
}


export default function FicheDetailsPage(props) {

    const params = useParams();
    const classes = useStyles();

    const [ficheDetails, setFicheDetails] = React.useState();
    const [isLoadingDetails, setIsLoadingDetails] = React.useState();
    const [ficheNotFound, setFicheNotFound] = React.useState(false);

    const location = useLocation();
    console.log(location)

    async function loadDetails() {

        try {

            setIsLoadingDetails(true);

            const response = await axios.get(
                `${LOAD_DETAILS}/${params.id}`,
                {
                }
            );

            setFicheDetails(response.data);

        } catch (e) {

            if (e.response && e.response.status === 404)
                setFicheNotFound(true)

        } finally {
            setIsLoadingDetails(false);
        }

    }

    const localState = React.useMemo(
        () => {
            if (ficheDetails) {
                let localState = convertToLocalState(ficheDetails.state);
                return localState;
            }
        }, [ficheDetails]
    )


    const steps = React.useMemo(
        () => {

            if (!ficheDetails)
                return [];

            const currentLocalState = localState;

            const prevStepArray = getSteps();
            const stepArray = [];

            //We choose 1, because the first step (fiche enregistrer) is not showed her, what is showed is rather fiche_validated
            for (let stepItem = 0; stepItem <= currentLocalState; stepItem++) {

                if (stepItem === 0) {
                    stepArray.push(`${prevStepArray[stepItem]} (${moment(ficheDetails.created_at).format('DD/MM/Y hh:mm')})`);
                    continue;
                }

                if (stepItem === 4)
                    continue;

                const date = '';

                console.log('step item', stepItem, date);

                if (date)
                    stepArray.push(`${prevStepArray[stepItem]} (${moment(date).format('DD/MM/Y hh:mm')})`);

                else
                    stepArray.push(`${prevStepArray[stepItem]}`);

            }

            return stepArray;
        }, [ficheDetails]
    );
    const activeStep = React.useMemo(
        () => {
            if (ficheDetails) {
                let localState = convertToLocalState(ficheDetails.state);
                console.log('local state ', localState);
                return localState - 1;
            }
        }, [ficheDetails]
    )


    React.useEffect(() => {

        loadDetails();

    }, [])

    return (
        <div className={`${classes.root} bg-white`}>

            {
                isLoadingDetails && (
                    <div>
                        En cours de chargement
                    </div>
                )
            }


            {
                ficheNotFound && (
                    <Redirect to={'/'}/>
                )
            }

            {
                ficheDetails && (

                    <div className={'row'}>

                        <div className={`${classes.details} col-12 px-5 py-5`}>

                            <div>

                                <SimpleTabMenu

                                    menu={[
                                        {
                                            to: `/fiches/details/${params.id}/state-histories`,
                                            label: 'Suivi'
                                        },
                                        {
                                            to: `/fiches/details/${params.id}/recapitulatif`,
                                            label: 'Récapitulatif'
                                        },
                                        {
                                            to: `/fiches/details/${params.id}/documents`,
                                            label: 'Documents'
                                        },
                                        {
                                            to: `/fiches/details/${params.id}/history`,
                                            label: 'Historique'
                                        },
                                    ]}


                                />

                            </div>


                            {/*{*/}
                            {/*    location.pathname == `/fiches/details/${params.id}` && (*/}
                            {/*        <div>*/}

                            {/*            <div>*/}

                            {/*                <div className={'row'}>*/}

                            {/*                    <div className={'col-md-4'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Type de la demande*/}

                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {societes[ficheDetails.type_travaux]}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-6'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Nature des travaux*/}

                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}

                            {/*                            {[...ficheDetails.nature_travaux_data.map(item => item.libelle), ficheDetails.autre_cie, ficheDetails.autre_sodeci]*/}
                            {/*                                .filter(item=>!!item).map(*/}
                            {/*                                    (item, index) => {*/}
                            {/*                                        if (index === ficheDetails.nature_travaux_data.length)*/}
                            {/*                                            return item;*/}

                            {/*                                        return item + ', ';*/}
                            {/*                                    }*/}
                            {/*                                )}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-8'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Description des travaux*/}

                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.description_travaux}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}


                            {/*                    {(*/}
                            {/*                        ficheDetails.type_travaux == 1 ||*/}
                            {/*                        ficheDetails.type_travaux == 3) && (*/}
                            {/*                        <>*/}

                            {/*                            <div className={'col-md-5'}>*/}

                            {/*                                <div className={'underlined small'}>*/}

                            {/*                                    Techniques des travaux*/}

                            {/*                                </div>*/}

                            {/*                                <div className={'h5'}>*/}
                            {/*                                    {ficheDetails.technique_travaux_data ?*/}
                            {/*                                        ficheDetails.technique_travaux_data.libelle : '-'*/}
                            {/*                                    }*/}
                            {/*                                </div>*/}

                            {/*                            </div>*/}

                            {/*                            <div className={'col-md-3'}>*/}

                            {/*                                <div className={'underlined small'}>*/}

                            {/*                                    Type de terrassement*/}

                            {/*                                </div>*/}

                            {/*                                <div className={'h5'}>*/}
                            {/*                                    {ficheDetails.technique_terrassement_type}*/}
                            {/*                                </div>*/}

                            {/*                            </div>*/}

                            {/*                            <div className={'col-md-1'}>*/}

                            {/*                                <div className={'underlined small'}>*/}
                            {/*                                    Hauteur*/}
                            {/*                                </div>*/}

                            {/*                                <div className={'h5'}>*/}
                            {/*                                    {ficheDetails.hauteur}*/}
                            {/*                                </div>*/}

                            {/*                            </div>*/}

                            {/*                            <div className={'col'}>*/}

                            {/*                                <div className={'underlined small'}>*/}

                            {/*                                    Moyens utilisés*/}

                            {/*                                </div>*/}

                            {/*                                <div className={'h5'}>*/}
                            {/*                                    {[ficheDetails.moyens_utilises.map(item=>item.libelle), ficheDetails.moyen_utilise_travaux_autre]*/}
                            {/*                                        .filter(item=>!!item).map(*/}
                            {/*                                            (item, index) => {*/}
                            {/*                                                if (index === ficheDetails.moyen_utilise_travaux.length)*/}
                            {/*                                                    return item;*/}

                            {/*                                                return item + ', ';*/}
                            {/*                                            }*/}
                            {/*                                        )}*/}
                            {/*                                </div>*/}

                            {/*                            </div>*/}

                            {/*                        </>*/}
                            {/*                    )*/}
                            {/*                    }*/}




                            {/*                    {*/}
                            {/*                        [*/}
                            {/*                            ficheDetails.plan_implentation_travaux,*/}
                            {/*                            ficheDetails.plan_implentation_travaux_fichier_2,*/}
                            {/*                            ficheDetails.plan_implentation_travaux_fichier_3,*/}
                            {/*                        ].filter(item => !!item).map(*/}
                            {/*                            item => {*/}
                            {/*                                return (*/}
                            {/*                                    <div className={'col-md-3'}>*/}

                            {/*                                        <div className={'underlined small'}>*/}

                            {/*                                            Fichier de plan d'implentation*/}

                            {/*                                        </div>*/}

                            {/*                                        <div className={'h5'}>*/}


                            {/*                                            {*/}
                            {/*                                                ficheDetails.fichiers_numerique_ouvrage.map(*/}
                            {/*                                                    item => {*/}
                            {/*                                                        return (*/}
                            {/*                                                            <a href={getFileUrl(item.value)} target='_blank'*/}
                            {/*                                                               className="btn btn-icon btn-light-primary">*/}
                            {/*                                                                <span className="flaticon-eye"></span>*/}
                            {/*                                                            </a>*/}
                            {/*                                                        );*/}
                            {/*                                                    }*/}
                            {/*                                                )*/}
                            {/*                                            }*/}


                            {/*                                        </div>*/}

                            {/*                                    </div>*/}
                            {/*                                )*/}
                            {/*                            }*/}
                            {/*                        )*/}
                            {/*                    }*/}


                            {/*                </div>*/}

                            {/*                <div className="row">*/}

                            {/*                    <div className="col-12">*/}
                            {/*                        <div className={'h2 text-primary font-weight-bold'}>*/}
                            {/*                            Localisation*/}

                            {/*                        </div>*/}
                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-6'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Equipement CIE/SODECI le plus proche*/}

                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.adresse_equipement_cie_proche}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-6'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Zone des travaux*/}

                            {/*                        </div>*/}

                            {/*                        {*/}
                            {/*                            ficheDetails.zone_travaux_file && (*/}

                            {/*                                <a href={getFileUrl(ficheDetails.zone_travaux_file)} className={'btn btn-icon btn-light-primary'}>*/}
                            {/*                                    <i className={'flaticon-eye'}/>*/}
                            {/*                                </a>*/}

                            {/*                            )*/}
                            {/*                        }*/}
                            {/*                        {*/}
                            {/*                            !ficheDetails.zone_travaux_file && (*/}
                            {/*                                <span>-</span>*/}
                            {/*                            )*/}
                            {/*                        }*/}


                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-3 my-3'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Villes*/}

                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.villes.map(*/}
                            {/*                                (item,index) => {*/}

                            {/*                                    if(index == ficheDetails.villes.length - 1)*/}
                            {/*                                        return item.libelle;*/}

                            {/*                                    return item.libelle + ', '*/}
                            {/*                                }*/}
                            {/*                            )}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-3 my-3'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Communes*/}

                            {/*                        </div>*/}


                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.communes.map(*/}
                            {/*                                (item,index) => {*/}

                            {/*                                    if(index == ficheDetails.communes.length - 1)*/}
                            {/*                                        return item.libelle;*/}

                            {/*                                    return item.libelle + ', '*/}
                            {/*                                }*/}
                            {/*                            )}*/}
                            {/*                        </div>*/}


                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-3 my-3'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Quartiers*/}

                            {/*                        </div>*/}


                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.quartiers.map(*/}
                            {/*                                (item,index) => {*/}

                            {/*                                    if(index == ficheDetails.quartiers.length - 1)*/}
                            {/*                                        return item.libelle;*/}

                            {/*                                    return item.libelle + ', '*/}
                            {/*                                }*/}
                            {/*                            )}*/}
                            {/*                        </div>*/}


                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-3 my-3'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Rues*/}

                            {/*                        </div>*/}


                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.rues.map(*/}
                            {/*                                (item,index) => {*/}

                            {/*                                    if(index == ficheDetails.rues.length - 1)*/}
                            {/*                                        return item.libelle;*/}

                            {/*                                    return item.libelle + ', '*/}
                            {/*                                }*/}
                            {/*                            )}*/}
                            {/*                        </div>*/}


                            {/*                    </div>*/}


                            {/*                    <div className={'col-md-6'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Description localisation*/}

                            {/*                        </div>*/}

                            {/*                        <div className="h5">*/}
                            {/*                            {ficheDetails.description_localisation}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-6'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Fichiers numérique de plan d'ouvrage*/}

                            {/*                        </div>*/}

                            {/*                        <div className="h5">*/}

                            {/*                            {*/}
                            {/*                                ficheDetails.fichiers_numerique_ouvrage.map(*/}
                            {/*                                    item => {*/}
                            {/*                                        return (*/}
                            {/*                                            <a href={getFileUrl(item.value)} target='_blank'*/}
                            {/*                                               className="btn btn-icon btn-light-primary">*/}
                            {/*                                                <span className="flaticon-eye"></span>*/}
                            {/*                                            </a>*/}
                            {/*                                        );*/}
                            {/*                                    }*/}
                            {/*                                )*/}
                            {/*                            }*/}

                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-12'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Description localisation*/}

                            {/*                        </div>*/}

                            {/*                        <div className="h5">*/}
                            {/*                            <GoogleMapsComponent*/}
                            {/*                                location={{*/}
                            {/*                                    lat: parseFloat(ficheDetails.geo_lat),*/}
                            {/*                                    lng: parseFloat(ficheDetails.geo_lng)*/}
                            {/*                                }}*/}
                            {/*                            />*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                </div>*/}

                            {/*                <div className="row">*/}


                            {/*                    <div className="col-12">*/}
                            {/*                        <div className={'h2 text-primary font-weight-bold'}>*/}
                            {/*                            Période*/}

                            {/*                        </div>*/}
                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-3'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Date de début des travaux*/}

                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {moment(ficheDetails.date_debut_travaux).format('DD/MM/YYYY')}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-3'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Date de fin des travaux*/}

                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {moment(ficheDetails.date_fin_travaux).format('DD/MM/YYYY')}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-6'}>*/}

                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Informations supplémentaires*/}

                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.informations_supplementaire}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className="col-12">*/}


                            {/*                        <div className={'underlined small'}>*/}

                            {/*                            Fichiers de planning des travaux*/}

                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}

                            {/*                            {*/}
                            {/*                                ficheDetails.planning_travaux.map(*/}
                            {/*                                    item => {*/}
                            {/*                                        return (*/}
                            {/*                                            <a href={getFileUrl(item.value)} target='_blank'*/}
                            {/*                                               className="btn btn-icon btn-light-primary">*/}
                            {/*                                                <span className="flaticon-eye"></span>*/}
                            {/*                                            </a>*/}
                            {/*                                        );*/}
                            {/*                                    }*/}
                            {/*                                )*/}
                            {/*                            }*/}

                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                </div>*/}

                            {/*                <div className={'row'}>*/}


                            {/*                    <div className="col-12">*/}
                            {/*                        <div className={'h2 text-primary font-weight-bold'}>*/}
                            {/*                            Contact*/}

                            {/*                        </div>*/}
                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-4'}>*/}

                            {/*                        <div className={'underlined small'}>*/}
                            {/*                            Type du client*/}
                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.type_client_data?.libelle}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    {*/}
                            {/*                        ficheDetails.type_client_id === 1 && (*/}
                            {/*                            <div className={'col-md-4'}>*/}

                            {/*                                <div className={'underlined small'}>*/}
                            {/*                                    Nom & Prenoms*/}
                            {/*                                </div>*/}

                            {/*                                <div className={'h5'}>*/}
                            {/*                                    {ficheDetails.nom} {ficheDetails.prenoms}*/}
                            {/*                                </div>*/}

                            {/*                            </div>*/}
                            {/*                        )*/}
                            {/*                    }*/}


                            {/*                    {*/}
                            {/*                        [2,3].includes(ficheDetails.type_client_id) && (*/}
                            {/*                            <div className={'col-md-4'}>*/}

                            {/*                                <div className={'underlined small'}>*/}
                            {/*                                    Raison sociale*/}
                            {/*                                </div>*/}

                            {/*                                <div className={'h5'}>*/}
                            {/*                                    {ficheDetails.raison_sociale}*/}
                            {/*                                </div>*/}

                            {/*                            </div>*/}
                            {/*                        )*/}
                            {/*                    }*/}

                            {/*                    <div className={'col-md-4'}>*/}

                            {/*                        <div className={'underlined small'}>*/}
                            {/*                            Email*/}
                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.email}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-4'}>*/}

                            {/*                        <div className={'underlined small'}>*/}
                            {/*                            Numéro de téléphone*/}
                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.mobile}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-4'}>*/}

                            {/*                        <div className={'underlined small'}>*/}
                            {/*                            Second Numéro de téléphone*/}
                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.mobile_2}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-4'}>*/}

                            {/*                        <div className={'underlined small'}>*/}
                            {/*                            Siège de sociale de l'entreprise*/}
                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.siege_sociale}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-4'}>*/}

                            {/*                        <div className={'underlined small'}>*/}
                            {/*                            Nom de l'entreprise*/}
                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.nom_enterprise}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-4'}>*/}

                            {/*                        <div className={'underlined small'}>*/}
                            {/*                            Nom du sous traitant*/}
                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.nom_sous_traitant}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-4'}>*/}

                            {/*                        <div className={'underlined small'}>*/}
                            {/*                            Nom responsable chantier*/}
                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.nom_prenoms_responsable_chantier}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-4'}>*/}

                            {/*                        <div className={'underlined small'}>*/}
                            {/*                            Contacts responsable chantier*/}
                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            {ficheDetails.contact_responsable_chantier}*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                    <div className={'col-md-4'}>*/}

                            {/*                        <div className={'underlined small'}>*/}
                            {/*                            Informations supplémentaires*/}
                            {/*                        </div>*/}

                            {/*                        <div className={'h5'}>*/}
                            {/*                            blabla*/}
                            {/*                        </div>*/}

                            {/*                    </div>*/}

                            {/*                </div>*/}

                            {/*            </div>*/}


                            {/*        </div>*/}
                            {/*    )*/}
                            {/*}*/}

                            <Route path="/fiches/details/:id/documents" component={DocumentsPage}/>
                            <Route path="/fiches/details/:id/history" component={HistoryPage}/>
                            <Route path="/fiches/details/:id/recapitulatif" component={RecapitulatifPage}/>
                            <Route path="/fiches/details/:id/state-histories" component={StatePage}/>

                        </div>


                    </div>

                )
            }

        </div>
    );

}